import FiltersWidget from "./FiltersWidget"
export default FiltersWidget
